<i18n>
{
  "no":{
    "errorHeading": "En feil har oppstått ved innlogging",
    "errorDescription": "Siden fungerer ikke uten informasjonskapsler/cookies. \n Du må tillate informasjonskapsler i din nettleser og laste siden på nytt",
    "cookieDetails": "Les mer om informasjonskapsler",
    "errorDetails": "Detaljer"
  },
  "en":{
    "errorHeading": "Oh no! We weren't able to log you in",
    "errorDescription": "This page does not work without cookies. \n Enable cookies in your browser and reload the page ",
    "cookieDetails": " ",
    "errorDetails": "Details"
  }
}
</i18n>

<template>
  <InfoScreen>
    <TnHeading type="h1" size="s" class="margin-bottom-l">{{ t('errorHeading') }}</TnHeading>
    <TnNotificationInline horizontal status="critical" full-width>
      <span class="pre-line">{{ t('errorDescription') }}</span>
      <div v-if="showCookieDetails" class="margin-top-m text-center">
        <TnLink
          href="https://www.telenor.no/om/personvern/informasjonskapsler/"
          :text="t('cookieDetails')"
        />
      </div>
    </TnNotificationInline>
  </InfoScreen>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  TnHeading,
  TnLink,
  TnNotificationInline,
} from '@telenornorgeinternal/telegrafen-vue3-core';

import InfoScreen from '@/components/InfoScreen.vue';

const { t } = useI18n();

// The English translation is a single space, which is intentionally falsy-ish
// here: trim() keeps the link hidden for 'en' exactly as before.
const showCookieDetails = computed(() => Boolean(t('cookieDetails').trim()));
</script>

<style scoped>
.pre-line {
  white-space: pre-line;
}
</style>
